var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._b({tag:"component",staticClass:"kvass-image-text",class:['kvass-image-text--theme-' + _vm.theme.toLowerCase()],attrs:{"value":_vm.value},scopedSlots:_vm._u([{key:"content",fn:function(item){return [_vm._t("content",null,null,item)]}}],null,true)},'component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }